module.exports = __webpack_public_path__ + "static/media/SCS_logo.5b8b1714.png";